import React from "react";
import {
  Card,
  CardHeader,
  CardBody,
  ListGroup,
  ListGroupItem,
  InputGroupText,
  InputGroup,
  FormCheckbox,
  InputGroupAddon,
  FormSelect,
  FormInput,
  Badge,
  Button,
  Alert,
} from "../../components/ui";
import withStorage from "./../../components/common/WithStorage";
import {
  publishPost,
  getAllEductionTopics,
  getPostTagSearch,
  updatePost,
} from "./../../api";
import { handleApiError } from "./../../utils/apiErrorHandler";
import DatePicker from "react-datepicker";
import publisherStore from "../../flux/publisherStore";
import NotificationService from "../../components/alerts";

class SidebarActions extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      profile: "",
      session: "",
      postCreated: false,
      publisherId: null,
      isHidden: false,
      visibility: true,
      isDraft: true,
      slug: "",
      submitDisabled: "",
      tagLine: "",
      searchLine: "",
      tags: [],
      educationalTopics: [],
      educationalTopicsSelected: [],
      suggestedTopicsSearchResults: [],
      tagSuggestions: [],
      showError: false,
    };
  }

  componentDidMount = async () => {
    let topics = await getAllEductionTopics();
    this.setState({
      profile: JSON.parse(localStorage.getItem("user")),
      publishers: publisherStore.getPublishers(),
      educationalTopics: topics.data,
    });
  };

  componentDidUpdate = (prevProps) => {
    const { post: nextPost } = this.props;
    const { post: prevPost } = prevProps;
    if (
      nextPost &&
      nextPost.tags &&
      nextPost.tags.length !== this.state.tags.length &&
      this.state.tags.length === 0
    ) {
      this.setState({
        tags: nextPost.tags,
      });
    }

    if (this.props && this.props.post && this.props.post.educationTopics &&
      (!prevPost || JSON.stringify(prevPost.educationTopics) !== JSON.stringify(this.props.post.educationTopics))) {
      this.setState({
        isHidden: this.props.post.isHidden,
        isDraft: this.props.post.isDraft,
        visibility: this.props.post.contentAvailabilityId === 2,
        educationalTopicsSelected: this.props.post.educationTopics.map(
          (t) => t.id,
        ),
      });

      return;
    }

    if (this.props && this.props.post && prevPost !== this.props.post) {
      this.setState({
        isHidden: this.props.post.isHidden,
        isDraft: this.props.post.isDraft,
        visibility: this.props.post.contentAvailabilityId === 2,
      });
    }
  };

  publish = async () => {
    this.setState({
      submitDisabled: "disabled",
    });
    const data = {
      authorId: this.state.publisherId,
      contentAvailabilityId: this.state.visibility ? 2 : 1, // 1 - false/public, 2 - true/member
      isHidden: this.state.isHidden,
      postContentTypeId: this.props.type ? 2 : 1, // 1 - false/Blog, 2 - true/Video
      isDraft: this.state.isDraft,
      title: this.props.title,
      slug: this.state.slug,
      excerpt: this.props.description,
      isCommunity: false,
      content: this.props.content,
      embeddedVideo: this.props.video,
      image: this.props.image,
      tags: this.state.tags.map((t) => t.name),
      suggestedPostIds: this.props.suggested.map((t) => t.id),
      educationTopicIds: this.state.educationalTopicsSelected,
    };

    const res = await publishPost(data);

    // Check if response is successful (status 200-299)
    if (res && res.status >= 200 && res.status < 300) {
      NotificationService.success("Post created successfully!");
      this.setState(
        {
          postCreated: true,
          showError: false,
          submitDisabled: "",
        },
        () => {
          if (this.props.onSidebarUpdate) {
            this.props.onSidebarUpdate(res && res.data);
          }
        },
      );
    } else {
      // Use centralized error handler for all error statuses
      const errorResponse = handleApiError(
        res,
        "An error occurred while creating the post. Please try again."
      );
      this.setState({
        showError: true,
        errorText: errorResponse.message,
        submitDisabled: "",
      });
    }
  };

  setPublishDate = (date) => {
    this.setState({ publishDate: date });
  };

  selectEducational = (event, id) => {
    let temp;
    if (this.state.educationalTopicsSelected.includes(id)) {
      temp = [...this.state.educationalTopicsSelected];
      const index = temp.indexOf(id);
      temp.splice(index, 1);
      this.setState({ educationalTopicsSelected: temp });
    } else {
      temp = [...this.state.educationalTopicsSelected];
      temp.push(id);
      this.setState({ educationalTopicsSelected: temp });
    }

    if (this.props.onSelectEducationalTopic) {
      this.props.onSelectEducationalTopic(
        this.state.educationalTopics.filter((educationalTopic) =>
          temp.includes(educationalTopic.id),
        ),
        this.state,
      );
    }
  };

  update = async () => {
    const data = {
      title: this.props.title,
      excerpt: this.props.description,
      content: this.props.content,
      tags: this.state.tags.map((t) => t.name),
      isDraft: this.state.isDraft,
      suggestedPostIds: this.props.suggested.map((t) => t.id),
      educationTopicIds: this.state.educationalTopicsSelected,
    };
    if (this.state.isHidden !== null) {
      data["isHidden"] = this.state.isHidden;
    }
    if (this.state.visibility !== null) {
      data["contentAvailabilityId"] = this.state.visibility ? 2 : 1;
    }
    if (this.props.image && this.props.image.indexOf("http") === -1) {
      data["image"] = this.props.image;
    }
    if (this.props.video !== null) {
      data["embeddedVideo"] = this.props.video;
    }
    if (this.state.publishDate) {
      var d = this.state.publishDate.getDate();
      var m = this.state.publishDate.getMonth() + 1;
      var y = this.state.publishDate.getFullYear();
      data["publishedAt"] =
        "" +
        y +
        "-" +
        (m <= 9 ? "0" + m : m) +
        "-" +
        (d <= 9 ? "0" + d : d) +
        " 12:00:00";
    }

    const res = await updatePost(this.props.post.id, data);

    // Check if response is successful (status 200-299)
    if (res && res.status >= 200 && res.status < 300) {
      NotificationService.success("Post updated successfully!");
      this.setState(
        {
          postUpdated: true,
          showError: false,
        },
        () => {
          this.props.reloadContent(res.data);
        },
      );
    } else {
      // Use centralized error handler for all error statuses
      const errorResponse = handleApiError(
        res,
        "An error occurred while updating the post. Please try again."
      );
      this.setState({
        showError: true,
        errorText: errorResponse.message,
      });
    }
  };

  visibility = () => {
    const visibility = !this.state.visibility;
    this.setState({ visibility }, () => {
      this.props.onSidebarUpdate({
        ...this.state,
        contentAvailabilityId: this.state.visibility ? 2 : 1,
      });
    });
  };

  isHidden = () => {
    const isHidden = !this.state.isHidden;
    this.setState({ isHidden }, () => {
      this.props.onSidebarUpdate({ ...this.state, isHidden });
    });
  };

  changePublisher = (event) => {
    const publisherId = event && event.target && event.target.value;
    this.setState({ publisherId }, () => {
      if (this.props.onChangePublisher) {
        this.props.onChangePublisher(publisherId);
      }

      if (this.props.onSidebarUpdate) {
        this.props.onSidebarUpdate(this.state);
      }
    });
  };

  setTags = async (event) => {
    const tag = event.target.value;
    this.setState({
      tagLine: tag,
    });
    let res = await getPostTagSearch(tag);
    if (res !== undefined) {
      this.setState({ tagSuggestions: res.data });
    }
  };

  clearTags = () => {
    this.setState({
      tagLine: "",
      tagSuggestions: [],
    });
  };

  addTag = (tag) => {
    this.setState({ tags: [...this.state.tags, tag] }, () => {
      this.props.onTagsUpdate(this.state.tags);
    });
    this.clearTags();
  };

  tagKeyPress = (e) => {
    if (e.keyCode === 13) {
      let val = e.target.value;
      this.addTag({
        name: val,
      });
    }
  };

  removeTag = (tag) => {
    let tags = this.state.tags;
    tags = tags.filter((t) => t.name !== tag.name);
    this.setState({ tags: tags }, () => {
      if (this.props.onTagsUpdate) {
        this.props.onTagsUpdate(this.state.tags);
      }
    });
  };

  changeStatus = (event) => {
    const isDraft = event.target.value === "true";
    this.setState({ isDraft }, () => {
      if (this.props.onSidebarUpdate) {
        this.props.onSidebarUpdate({ ...this.state, isDraft });
      }
    });
  };

  render() {
    const user = this.props.load("user");
    const postId = this.props.post && this.props.post.id;
    return (
      <React.Fragment>
        <Card className="mb-3">
          <CardHeader className="border-bottom">
            <h6 className="m-0">Options</h6>
          </CardHeader>
          <CardBody className="p-0">
            <ListGroup flush>
              {user && user.userRoleId === 1 && (
                <ListGroupItem className="p-3">
                  <span className="d-flex align-items-center mb-3">
                    <i className="material-icons mr-1">money</i>
                    <strong className="mr-1">
                      Content Availability :
                    </strong>{" "}
                    <FormCheckbox
                      toggle
                      small
                      checked={this.state.visibility}
                      onChange={this.visibility}
                    >
                      {this.state.visibility ? "Paid" : "Free"}
                    </FormCheckbox>
                  </span>
                  <span className="d-flex align-items-center mb-3">
                    <i className="material-icons mr-1">visibility</i>
                    <strong className="mr-1">Is Hidden :</strong>{" "}
                    <FormCheckbox
                      toggle
                      small
                      checked={!this.state.isHidden}
                      onChange={this.isHidden}
                    >
                      {this.state.isHidden ? "Hidden" : "Visible"}
                    </FormCheckbox>
                  </span>
                  <span className="d-flex mb-2">
                    <label htmlFor="feInputState">Publish on behalf of</label>
                    <FormSelect
                      id="feInputState"
                      onChange={this.changePublisher}
                    >
                      <option>Choose...</option>
                      {this.state.publishers &&
                        this.state.publishers.map((publisher) => (
                          <option
                            key={publisher.id}
                            selected={
                              this.props.post &&
                              this.props.post.publisher &&
                              publisher.id === this.props.post.publisher.id
                            }
                            value={publisher.id}
                          >
                            {publisher.name}
                          </option>
                        ))}
                    </FormSelect>
                  </span>
                </ListGroupItem>
              )}

              <ListGroupItem className="p-3 custom-no-padding-top">
                <label className="d-flex mb-2" htmlFor="feInputState">
                  Status
                </label>
                <span className="d-flex mb-2">
                  <FormSelect id="feInputState" onChange={this.changeStatus}>
                    <option selected={this.state.isDraft === true} value={true}>
                      Draft
                    </option>
                    <option
                      selected={this.state.isDraft === false}
                      value={false}
                    >
                      Published
                    </option>
                  </FormSelect>
                </span>
                <label className="mt-3" htmlFor="feInputState">
                  Publish Date
                </label>
                <span className="d-flex mb-2" style={{ width: "100%" }}>
                  <DatePicker
                    id="datepicker"
                    selected={this.state.publishDate}
                    dateFormat="yyyy-MM-dd HH:mm:ss"
                    onChange={this.setPublishDate}
                  />
                </span>
                <label className="mt-3" htmlFor="feInputState">
                  Tags
                </label>
                <InputGroup seamless>
                  <FormInput
                    size="lg"
                    placeholder="Search ..."
                    onKeyDown={this.tagKeyPress}
                    onChange={this.setTags}
                    value={this.state.tagLine}
                  />
                  <InputGroupAddon type="append">
                    <InputGroupText onClick={this.clearTags}>
                      <i className="material-icons">clear</i>
                    </InputGroupText>
                  </InputGroupAddon>
                </InputGroup>
                <ListGroup small flush className="list-group-small">
                  {this.state.tagSuggestions.map((tag) => (
                    <ListGroupItem
                      key={tag.id}
                      className="d-flex px-3"
                      onClick={() => this.addTag(tag)}
                    >
                      <span className="text-semibold text-fiord-blue">
                        {tag.name}
                      </span>
                    </ListGroupItem>
                  ))}
                </ListGroup>
                <br />
                {this.state.tags.map((tag) => (
                  <Badge
                    pill
                    className={`card-post__category badge-content-tag`}
                  >
                    <i
                      class="material-icons mr-1 tag-remove"
                      onClick={() => this.removeTag(tag)}
                    >
                      close
                    </i>{" "}
                    {tag.name}
                  </Badge>
                ))}
                <br />
              </ListGroupItem>
              <ListGroupItem className="d-flex px-3 border-0">
                {!postId && (
                  <Button
                    theme="accent"
                    size="sm"
                    className="ml-auto"
                    disabled={this.state.submitDisabled}
                    onClick={this.publish}
                  >
                    <i className="material-icons">file_copy</i> Submit
                  </Button>
                )}
                {!!postId && (
                  <Button
                    theme="accent"
                    size="sm"
                    className="ml-auto"
                    onClick={this.update}
                  >
                    <i className="material-icons">file_copy</i> Update
                  </Button>
                )}
              </ListGroupItem>
            </ListGroup>
          </CardBody>
          {this.state.postCreated && (
            <Alert className="mb-0">
              <i className="fa fa-info mx-2"></i> Post created!
            </Alert>
          )}
          {this.state.postUpdated && (
            <Alert className="mb-0">
              <i className="fa fa-info mx-2"></i> Post updated!
            </Alert>
          )}
          {this.state.showError && (
            <Alert className="mb-0">
              <i className="fa fa-error mx-2"></i>
              {this.state.errorText}
            </Alert>
          )}
        </Card>

        <Card className="mb-3">
          <CardHeader className="border-bottom">
            <h6 className="m-0">Education</h6>
          </CardHeader>
          <CardBody className="p-0">
            <ListGroup flush>
              <ListGroupItem className="p-3">
                <fieldset>
                  {this.state.educationalTopics.map((topic) => (
                    <FormCheckbox
                      checked={this.state.educationalTopicsSelected.includes(
                        topic.id,
                      )}
                      key={topic.id}
                      value={topic.id}
                      onChange={(e) => this.selectEducational(e, topic.id)}
                    >
                      {topic.name}
                    </FormCheckbox>
                  ))}
                </fieldset>
              </ListGroupItem>
            </ListGroup>
          </CardBody>
        </Card>
      </React.Fragment>
    );
  }
}

export default withStorage(SidebarActions);
